import {useContext} from 'react';
import {AuthenticationConfig, AuthenticationContext} from './ctx';

export const useAuthenticationPrompt = () => {
  const {showUserAuthenticationPrompt} = useContext(AuthenticationContext);

  if (!showUserAuthenticationPrompt) {
    console.warn(
      'Cannot find value for AuthenticationContext. Did you add a AuthenticationContext in one of the parent components?',
    );
    return {
      showUserAuthenticationPrompt: () => {},
    };
  }

  return {showUserAuthenticationPrompt} as AuthenticationConfig;
};
